import { useForm } from "react-hook-form";
import { BoxInner, ErrMsg } from "../../../style/contents/backup/backup";
import { UserProfile } from "../../../view/contents/user/user.list";
import { useEffect } from "react";
import { fetchUserEditProfile, ResponseData } from "../../../api/admin";
import { fetchUpdatePasswordAdmin } from "../../../api/auth";
import { formatPhoneNumber } from "../../../util/util";

interface ModalProps {
  closedHandler: () => void;
  user: UserProfile;
}

const ModifyModal = ({ closedHandler, user }: ModalProps) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
  } = useForm();

  console.log(user);

  const onSubmit = async (data: any) => {
    const adminUserId = localStorage.getItem("userId") ?? "";
    const responseData: ResponseData = {
      adminUserId,
      userId: user.userId,
      username: data.userName, // ✅ 변경된 이름 반영
      userEmail: data.userEmail ?? "", // ✅ 이메일 입력란이 있다면 반영 (없으면 "")
      phoneNumber: data.phoneNumber ?? "",
      jobPosition: data.jobPosition,
      permission: data.role === "admin" ? "admin" : "client", // ✅ 권한
      department: data.department,
      disable: false,
    };

    // 비밀번호가 제공된 경우에만 비밀번호를 변경
    if (data.password) {
      try {
        const res = await fetchUpdatePasswordAdmin(user.userId, data.password);
        console.log("비밀번호 변경 성공:", res);
        alert("비밀번호가 성공적으로 변경되었습니다.");
      } catch (err) {
        console.error("비밀번호 변경 실패:", err);
        alert("비밀번호 변경에 실패했습니다. 다시 시도해주세요.");
      }
    }

    try {
      const res = await fetchUserEditProfile(responseData);
      console.log("res", res);
      alert("구성원이 성공적으로 수정되었습니다.");
      closedHandler();
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (user) {
      reset({
        userAccount: user.userAccount,
        userName: user.userName,
        department: user.department, // user에 없다면 빈 문자열
        jobPosition: user.jobPosition,
        userEmail: user.userEmail,
        phoneNumber: user.phoneNumber,
        role: user.isAdmin ? "admin" : "user",
      });
    }
  }, [user, reset]);

  return (
    <BoxInner>
      <div className="modal-header">
        <p>구성원 수정</p>
        <button
          onClick={closedHandler}
          className="closed-modal-btn"
          style={{ cursor: "pointer" }}
        >
          <img src="/assets/Close_Icons_UIA.svg" alt="" />
        </button>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="info">
          <p>구성원 정보 입력</p>
        </div>
        <table>
          <tbody>
            <tr>
              <th>아이디</th>
              <td>
                <input
                  type="text"
                  readOnly
                  {...register("userAccount", { required: true })}
                  style={{ backgroundColor: "#f5f5f5", cursor: "not-allowed" }} // UX 개선용 스타일 (선택)
                />
              </td>
            </tr>
            <tr>
              <th>비밀번호</th>
              <td>
                <input
                  type="password"
                  {...register("password", {
                    pattern: {
                      value:
                        /^(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+={}:;"'<>,.?/-]).{10,}$/,
                      message:
                        "비밀번호는 최소 10자 이상, 소문자, 숫자, 특수기호가 포함되어야 합니다.",
                    },
                  })}
                />
              </td>
            </tr>
            <tr>
              <th>비밀번호 확인</th>
              <td>
                <input
                  type="password"
                  {...register("confirmPassword", {
                    validate: (value) =>
                      value === watch("password") ||
                      "비밀번호가 일치하지 않습니다",
                  })}
                />
              </td>
            </tr>
            <tr>
              <th>이름</th>
              <td>
                <input
                  type="text"
                  {...register("userName", { required: true })}
                />
              </td>
            </tr>
            <tr>
              <th>부서명</th>
              <td>
                <input
                  type="text"
                  {...register("department", {
                    required: "부서는 필수 입력입니다.", // ✅ 필수 조건 추가
                  })}
                />
              </td>
            </tr>
            <tr>
              <th>직위</th>
              <td>
                <input type="text" {...register("jobPosition")} />
              </td>
            </tr>
            <tr>
              <th>이메일</th>
              <td>
                <input type="email" {...register("userEmail")} />
              </td>
            </tr>
            <tr>
              <th>전화번호</th>
              <td>
                <input
                  type="text"
                  maxLength={13}
                  placeholder="010-1234-5678"
                  {...register("phoneNumber")}
                  onChange={(e) => {
                    e.target.value = formatPhoneNumber(e.target.value);
                  }}
                />
              </td>
            </tr>
            <tr>
              <th>권한</th>
              <td>
                <div className="radio-box">
                  <div className="radio">
                    <input
                      type="radio"
                      id="user-radio"
                      value="user"
                      {...register("role", { required: true })}
                    />
                    <label htmlFor="user-radio">사용자</label>
                  </div>
                  <div className="radio">
                    <input
                      type="radio"
                      id="admin-radio"
                      value="admin"
                      {...register("role", { required: true })}
                    />
                    <label htmlFor="admin-radio">관리자</label>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        {errors.password && (
          <ErrMsg>
            {typeof errors.password.message === "string"
              ? errors.password.message
              : ""}
          </ErrMsg>
        )}
        {!errors.password && errors.confirmPassword && (
          <ErrMsg>
            {typeof errors.confirmPassword.message === "string"
              ? errors.confirmPassword.message
              : ""}
          </ErrMsg>
        )}
        {errors.department && (
          <ErrMsg>{errors.department.message as string}</ErrMsg>
        )}

        <div className="btn-box">
          <button type="submit" className="regist">
            수정
          </button>
          <button type="button" className="cancel" onClick={closedHandler}>
            취소
          </button>
        </div>
      </form>
    </BoxInner>
  );
};

export default ModifyModal;
